/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_Sign_UpInputs */

const en_common_nav_sign_up = /** @type {(inputs: Common_Nav_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up`)
};

const zh_common_nav_sign_up = /** @type {(inputs: Common_Nav_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册`)
};

/**
* | output |
* | --- |
* | "Sign up" |
*
* @param {Common_Nav_Sign_UpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_nav_sign_up = /** @type {((inputs?: Common_Nav_Sign_UpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_Sign_UpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_nav_sign_up(inputs)
	return zh_common_nav_sign_up(inputs)
});
export { common_nav_sign_up as "common.nav.sign_up" }